/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsChampionMasteryDtoSchema = z.object({
  championId: z.optional(z.int()),
  championName: z.string().nullish(),
  championImageUrl: z.string().nullish(),
  championLevel: z.optional(z.int()),
  championPoints: z.optional(z.int()),
  lastPlayTime: z.optional(z.iso.datetime()),
});
